exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-button {\n  border-color: #2ec58d;\n  background-color: #2ec58d;\n  color: white !important; }\n  .add-button:hover {\n    background-color: #27a677;\n    border-color: #249c6f; }\n", ""]);

// exports
